import doohHero from "@/assets/dooh-3d-hero.png";
import { SectionHeader } from "@/components/shared/SectionHeader";

export const DOOHShowcaseSection = () => {
  return (
    <section className="relative">
      <SectionHeader
        eyebrow="DOOH Network"
        title="Every face, every format"
        subtitle="From building facades and bridge gantries to MUPIs, totems, and unipoles — plan across every DOOH face type from a single platform."
      />
      <div className="relative isolate mt-10 md:mt-14">
        {/* Themed ambient field — unframed so the transparent render blends into the page */}
        <div
          aria-hidden
          className="pointer-events-none absolute -inset-x-10 -inset-y-20 -z-10 overflow-hidden sm:-inset-x-16 lg:-inset-x-24"
        >
          {/* Page-matched wash with no visible rectangle or rounded frame */}
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,hsl(var(--primary)/0.07),transparent_62%)] dark:bg-[radial-gradient(ellipse_at_center,hsl(var(--primary)/0.12),transparent_62%)]" />
          {/* Primary radial glow, animated */}
          <div
            className="absolute left-1/2 top-1/2 h-[72%] w-[82%] -translate-x-1/2 -translate-y-1/2 rounded-full blur-3xl opacity-35 animate-pulse"
            style={{
              background:
                "radial-gradient(closest-side, hsl(var(--primary) / 0.22), hsl(var(--primary) / 0.06) 56%, transparent 78%)",
            }}
          />
          {/* Accent off-center glow */}
          <div
            className="absolute right-[8%] top-[8%] h-[42%] w-[42%] rounded-full blur-3xl opacity-25"
            style={{
              background:
                "radial-gradient(closest-side, hsl(var(--primary) / 0.16), transparent 72%)",
            }}
          />
        </div>

        <img
          src={doohHero}
          alt="3D illustration of digital out-of-home faces displaying Fusion Media creative"
          width={1536}
          height={1024}
          loading="lazy"
          className="relative mx-auto w-full max-w-5xl"
        />
      </div>
    </section>
  );
};
